import { useApiToast } from 'components/Toaster';
import { useEffect, useState } from 'react';
import { useGetPersonsMutation } from 'services/person/person.endpoint';
import { Person } from 'services/person/person.types';

export default function useLastPersonsVM() {
    return {

    };
}
